import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IEnvironment } from '../../ui/models/environment.model';
import { IResponse } from '../../ui/models/response.model';

/**
 * Response from the virus scanning API
 */
export interface VirusScanResponse {
  clean: boolean;
  status: string;
  virusThreats?: string;
}

/**
 * Service for scanning files for viruses
 */
@Injectable({
  providedIn: 'root',
})
export class VirusScanService {
  private readonly SCAN_ENDPOINT = '/application/v1/files/scan';

  constructor(
    private http: HttpClient,
    @Inject('environment') private environment: IEnvironment
  ) {}

  /**
   * Scans a file for viruses using the backend API
   * @param file The file to scan
   * @returns An Observable of the scan result
   */
  scanFile(file: File): Observable<IResponse<VirusScanResponse>> {
    const formData = new FormData();
    formData.append('file', file);

    const scanUrl = `${this.environment.apiGatewayBaseUrl}${this.SCAN_ENDPOINT}`;
    return this.http.post<IResponse<VirusScanResponse>>(scanUrl, formData);
  }
}
